export default __webpack_public_path__ + "static/media/11.34319947.webp";